import { CSSProperties, useState } from 'react';

import { NorlysFont } from '~src/branding';
import { AddressInputNorlys } from '~src/components/AddressInput';
import { ButtonNorlys } from '~src/components/Button';
import { CalculatorFooterNorlys } from '~src/components/Footer/CalculatorFooter';
import { CalculatorHeaderNorlys } from '~src/components/Header/CalculatorHeader/norlys';
import { InfoBoxWithImage } from '~src/components/InfoBoxWithImage';
import { Root } from '~src/components/Root';
import { useDisplayContext } from '~src/context/DisplayContext';
import { CUSTOMER_ADDRESS, useCachedState } from '~src/hooks/useCachedState';
import { useCalculatorNavigation } from '~src/hooks/useNavigation';
import { Address } from '~src/model';

import bodilHelpers from '~shared-assets/images/bodil-helpers.jpg';

import { Container, TextNorlys } from './style';

export const AddressPageNorlys = () => {
  const [, setAddress] = useCachedState<Partial<Address>>(CUSTOMER_ADDRESS);
  const [stage, setStage] = useState<1 | 2>(1);

  const { isMobile } = useDisplayContext();
  const navigate = useCalculatorNavigation('address');

  const pageStyle: CSSProperties = {
    paddingTop: isMobile ? '88px' : '136px',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  };

  const textStyle = isMobile
    ? undefined
    : {
        ...NorlysFont.style('heading', 59),
        margin: '50px 0 30px 0',
      };

  return (
    <Root header={<CalculatorHeaderNorlys />} footer={<CalculatorFooterNorlys />} pageStyle={pageStyle}>
      <Container {...{ style: { width: '100%', height: '100%', marginTop: 0 } }}>
        {isMobile && stage === 1 ? (
          <>
            <InfoBoxWithImage imageURL={bodilHelpers} />

            <ButtonNorlys onClick={() => setStage(2)}>Start</ButtonNorlys>
          </>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <TextNorlys style={textStyle}>Indtast din adresse og start energiberegningen</TextNorlys>

            <AddressInputNorlys
              {...{
                size: 'large',
                style: { zIndex: 10, marginBottom: '32px' },
                onChange: (address?: Partial<Address>) => {
                  setAddress(address);

                  navigate('information');
                },
              }}
            />

            {!isMobile && <InfoBoxWithImage imageURL={bodilHelpers} />}
          </div>
        )}
      </Container>
    </Root>
  );
};
